// AUTO-GENERATED by `npm run codegen:ui` - do not edit.
namespace $ {

export type easyreels_user_upload_startMutationVariables = Exact<{
  input: StartFileUploadInput;
}>;


export type easyreels_user_upload_startMutation = { __typename?: 'Mutation', startFileUpload: { __typename: 'ErrorPayload', message: string } | { __typename: 'QuotaExceededPayload', usedBytes: number, limitBytes: number } | { __typename: 'StartFileUploadPayload', partBytes: number, partCount: number, recording: { __typename?: 'Recording', id: number } } };


export function $easyreels_user_upload_start(variables: easyreels_user_upload_startMutationVariables, opts?: { revalidate?: boolean }): easyreels_user_upload_startMutation {
	return $easyreels_gql_user_request(`mutation easyreels_user_upload_start(\u0024input: StartFileUploadInput!) {
  startFileUpload(input: \u0024input) {
    __typename
    ... on StartFileUploadPayload {
      recording {
        id
      }
      partBytes
      partCount
    }
    ... on QuotaExceededPayload {
      usedBytes
      limitBytes
    }
    ... on ErrorPayload {
      message
    }
  }
}`, variables, opts) as easyreels_user_upload_startMutation
}

}
